import React, { Component } from 'react'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import InViewMonitor from 'react-inview-monitor'
import easing from 'ui/styles/easing'

import TimeDisplay from './TimeDisplay'
import Controls from './Controls'
import Text from './Text'
import Clock from './Clock'
import Image from './Image'

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 80px;
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};
  background: ${props => props.theme.colors.grey.lightest};
  padding: 30px 0;

  ${media.lg`
    background: none;
    padding: 18% 0 0;
  `}
`

const RelativeContainer = styled(Container)`
  position: relative;
  z-index: 1;
`

const Heading = styled.h2`
  font-size: 32px;
  color: ${props => props.theme.colors.theme.base};
`

const FilledWrapper = styled.div`
  background: ${props => props.theme.colors.theme.light};
  display: flex; 
  position: relative;
  z-index: 1;
`

const RelativeRow = styled(Row)`
  position: relative;
`

const PulledCol = styled(Col)`
  ${media.lg`
    transform: translateY(-5%);
  `}

  ${media.xl`
    transform: translateY(-25%);
  `}
`

const ImageCol = styled(Col)`
  right: 0;
  bottom: 0;

  ${media.lg`
    position: absolute;
  `}
`

const Background = styled.div`
  background: ${props => props.theme.colors.grey.lightest};
  width: 50%;
  position: absolute;
  left: 0;
  height: 80%;
  bottom: 10%;
  z-index: 0;
  display: none;

  ${media.lg`
    display: block;
  `}
`

export default class DaySlider extends Component {
  constructor(props) {
    super(props)

    this.nextTime = this.nextTime.bind(this)
    this.prevTime = this.prevTime.bind(this)
  }

  state = {
    activeTime: 0
  }

  nextTime() {
    const { times } = this.props
    const { activeTime } = this.state
    const newTime = activeTime + 1
    
    if(newTime <= times.length - 1) {
      this.setState({ activeTime: newTime })
    }
  }
  
  prevTime() {
    const { activeTime } = this.state
    const newTime = activeTime - 1
    
    if(newTime >= 0) {
      this.setState({ activeTime: newTime })
    }
  }
  
  render() {
    const {
      heading,
      times,
    } = this.props
    
    const { activeTime } = this.state

    return(
      <InViewMonitor childPropsInView={{inView: true}}>
        <Wrapper>
        
          <RelativeContainer fluid>
            
            <Row>
              <PulledCol lg={5}>
                <Heading>{heading}</Heading>
                <TimeDisplay
                  times={times}
                  activeTime={activeTime}
                />
              </PulledCol>
            </Row>
            
            <RelativeRow>
              <Col
                xsOrder={2}
                smOrder={2}
                lg={7}
              >
                <Controls
                  activeTime={activeTime}
                  length={times.length}
                  next={this.nextTime}
                  prev={this.prevTime}
                />
                <FilledWrapper>
                  <Clock
                    times={times}
                    activeTime={activeTime}
                    />
                  <Text
                    title={times[activeTime].title}
                    text={times[activeTime].text}
                  />
                </FilledWrapper>
              </Col>
              <ImageCol
                xsOrder={1}
                smOrder={1}
                lg={7}
              >
                <Image image={times[activeTime].image.sourceUrl} />
              </ImageCol>
            </RelativeRow>
          
          </RelativeContainer>
          
          <Background />
        
        </Wrapper>
      </InViewMonitor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/DaySlider/index.js